var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h2',{staticClass:"otb-summary__license-warning-message",class:_vm.warningMessageClass,domProps:{"innerHTML":_vm._s(_vm.message)}})
}
var staticRenderFns = []

export { render, staticRenderFns }